import { PositionScenarios } from "../../types";

export const lec2Scenarios: PositionScenarios = {
  "1": {
    "1": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 0, "8": 1, "10": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 1, "9": 0, "10": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 0, "6": 1, "9": 1, "11": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 0, "8": 1, "10": 1, "11": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "9": 0, "10": 0, "11": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "9": 1, "11": 1, "12": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "11": 1, "12": 0, "13": 0 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "6": 1, "7": 1, "9": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 0, "8": 1, "10": 1, "11": 0 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "6": 0, "8": 1, "10": 1, "12": 0 },
      { "1": 0, "2": 1, "3": 0, "5": 0, "6": 0, "8": 1, "12": 0, "13": 1 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 1, "9": 0, "10": 0, "11": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 1, "9": 1, "11": 1, "12": 1 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 1, "11": 1, "12": 0, "13": 0 },
      { "1": 0, "2": 0, "4": 1, "5": 1, "6": 0, "8": 1, "12": 0, "13": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 1, "9": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "9": 1, "11": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 0, "8": 1, "10": 1 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 1, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 1, "9": 1, "11": 0 },
      { "2": 1, "3": 1, "6": 0, "8": 1, "10": 0, "11": 0, "12": 0 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 1, "14": 0 },
      { "2": 1, "3": 1, "6": 1, "9": 0, "10": 1, "11": 0, "12": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 1, "9": 1 },
    ],
    "2": [],
    "3": [],
    "4": [],
    "5": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 1, "6": 1, "9": 1, "11": 0 },
      { "1": 0, "2": 1, "3": 0, "5": 1, "6": 1, "9": 1, "11": 1, "13": 0 },
      { "1": 0, "3": 0, "4": 1, "6": 1, "9": 1, "11": 0, "12": 1 },
    ],
    "6": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
    ],
    "7": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      { "1": 0, "2": 0, "3": 1, "4": 0, "5": 1, "6": 0, "8": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 1, "6": 0, "8": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 0, "6": 0, "8": 1, "12": 1 },
      { "1": 0, "2": 0, "3": 1, "4": 0, "5": 1, "6": 1, "9": 0, "10": 1 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 1, "6": 1, "9": 0, "10": 1 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 0, "6": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 0, "3": 1, "4": 1, "6": 0, "8": 1, "10": 0, "12": 1 },
      { "1": 0, "2": 0, "3": 1, "4": 1, "6": 1, "9": 0, "10": 1, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "5": 0, "6": 0, "8": 1, "10": 1, "12": 1 },
      { "1": 1, "2": 0, "3": 1, "5": 1, "6": 0, "8": 1, "10": 0, "12": 1 },
      { "1": 1, "2": 0, "3": 1, "5": 1, "6": 1, "9": 0, "10": 1, "12": 1 },
      { "1": 1, "3": 0, "4": 0, "5": 1, "6": 0, "8": 1, "12": 0, "13": 0 },
      { "1": 1, "3": 0, "4": 0, "5": 1, "6": 1, "9": 0, "12": 0, "13": 0 },
      { "2": 1, "3": 0, "5": 0, "6": 0, "8": 0, "11": 0, "12": 0, "13": 0 },
      { "2": 0, "4": 1, "5": 1, "6": 0, "8": 0, "11": 0, "12": 0, "13": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 0, "6": 0, "8": 1, "12": 1 },
      { "1": 1, "2": 1, "3": 0, "4": 0, "6": 1, "9": 0, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "5": 1, "6": 0, "8": 1, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "5": 1, "6": 1, "9": 0, "12": 1 },
      { "2": 1, "3": 0, "5": 0, "6": 0, "8": 0, "11": 0, "12": 1 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 1, "14": 1 },
      { "2": 0, "4": 1, "5": 1, "6": 0, "8": 0, "11": 0, "12": 1 },
      { "1": 1, "2": 0, "5": 0, "6": 0, "8": 1, "10": 0 },
      { "1": 1, "2": 0, "5": 0, "6": 1, "9": 0, "10": 1 },
      { "1": 0, "3": 0, "6": 0, "8": 1, "10": 0, "12": 1 },
      { "1": 0, "3": 0, "6": 1, "9": 0, "10": 1, "12": 1 },
      { "2": 1, "3": 0, "5": 0, "6": 0, "8": 0, "11": 1 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 0 },
      { "2": 0, "4": 1, "5": 1, "6": 0, "8": 0, "11": 1 },
      { "2": 1, "3": 0, "5": 1, "6": 0, "8": 0 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 1 },
      { "2": 0, "4": 1, "5": 0, "6": 0, "8": 0 },
      { "2": 0, "4": 0, "6": 0, "8": 0 },
    ],
    "8": [
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      { "2": 0, "3": 1, "4": 0, "6": 0, "8": 1, "10": 1, "11": 0, "14": 0 },
      { "2": 0, "3": 1, "4": 0, "6": 1, "9": 0, "10": 0, "11": 0, "14": 0 },
      { "2": 0, "3": 1, "6": 0, "8": 1, "10": 1, "11": 1, "13": 0, "14": 1 },
      { "2": 0, "3": 1, "6": 1, "9": 0, "10": 0, "11": 1, "13": 0, "14": 1 },
    ],
    "9": [],
    "10": [],
  },
  "2": {
    "1": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 0, "8": 0, "11": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 1, "5": 0, "7": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 0, "8": 0, "11": 1, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 0, "8": 0, "10": 1, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 1, "9": 1, "10": 0, "12": 1 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "6": 1, "7": 1, "9": 0, "12": 1 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 0, "8": 0, "11": 1, "12": 1 },
      { "1": 1, "2": 1, "3": 0, "5": 1, "7": 1, "9": 0, "12": 0, "13": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 1, "9": 0, "12": 1 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 0, "8": 0, "11": 1 },
      { "1": 1, "2": 1, "3": 0, "5": 1, "7": 1, "9": 0, "12": 1 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 1, "14": 1 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 0 },
    ],
    "2": [],
    "3": [],
    "4": [],
    "5": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 1, "6": 0, "8": 0, "11": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "5": 1, "6": 0, "8": 0, "12": 0 },
      { "1": 0, "2": 1, "3": 0, "5": 1, "6": 0, "8": 0, "11": 1, "13": 0 },
      { "1": 0, "2": 1, "3": 0, "6": 0, "8": 1, "10": 0, "11": 0, "12": 1 },
      { "1": 0, "2": 1, "3": 0, "6": 1, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "1": 0, "3": 0, "4": 1, "6": 0, "8": 0, "11": 0, "12": 1 },
    ],
    "6": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
    ],
    "7": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 1, "7": 1, "10": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 1, "6": 0, "8": 1, "10": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "7": 1, "10": 0, "12": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 0, "8": 1, "10": 1, "12": 1 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "6": 1, "7": 1, "9": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 1, "7": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 1, "7": 1, "10": 0, "12": 1 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "6": 0, "8": 1, "10": 1, "12": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 1, "6": 0, "8": 1, "10": 1, "12": 1 },
      { "1": 0, "2": 1, "3": 1, "5": 0, "6": 0, "8": 1, "12": 0, "13": 0 },
      { "1": 0, "2": 1, "3": 1, "5": 0, "6": 1, "9": 0, "12": 0, "13": 0 },
      { "1": 1, "2": 1, "5": 0, "6": 1, "7": 0, "8": 0, "9": 1, "10": 1 },
      { "1": 1, "2": 1, "5": 0, "6": 1, "7": 1, "9": 1, "10": 1, "12": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 1, "7": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 0, "8": 1, "10": 1 },
      { "2": 1, "3": 1, "6": 0, "8": 0, "11": 0, "13": 1, "14": 0 },
    ],
    "8": [
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      { "1": 1, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "8": 0, "12": 0 },
      { "3": 1, "4": 1, "5": 1, "6": 1, "9": 1, "11": 0, "12": 0, "13": 1 },
    ],
    "9": [],
    "10": [],
  },
  "3": {
    "1": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 0, "7": 0, "8": 0, "10": 1 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 0, "7": 1, "9": 1, "10": 0 },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 1, "7": 1, "9": 0, "11": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 1, "5": 0, "7": 1, "9": 0, "11": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 1, "7": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 1, "7": 1, "11": 1, "13": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 0, "5": 1, "7": 1, "12": 0, "13": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 0, "8": 1, "11": 1, "12": 1 },
      { "1": 0, "2": 1, "3": 0, "4": 1, "7": 1, "9": 0, "11": 0, "12": 1 },
      { "1": 0, "2": 0, "4": 1, "5": 0, "6": 0, "7": 1, "11": 1, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 0, "8": 0, "10": 1, "12": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 0, "8": 0, "10": 0, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 0, "8": 1, "11": 0, "13": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 1, "9": 1, "10": 0, "12": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 1, "9": 1, "10": 1, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "7": 0, "8": 0, "10": 0, "12": 1, "13": 0 },
      { "1": 0, "2": 0, "4": 0, "7": 1, "9": 1, "10": 1, "12": 1, "13": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 0, "7": 1, "9": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 0, "8": 0, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 0, "8": 0, "10": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 1, "9": 1, "10": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 0, "4": 1, "7": 1, "9": 0, "11": 0, "12": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 1, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 1, "9": 0 },
    ],
    "2": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
    ],
    "3": [
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
    ],
    "4": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
    ],
    "5": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 0, "2": 1, "3": 0, "4": 0, "7": 1, "9": 0, "11": 1, "13": 1 },
      { "1": 0, "2": 1, "3": 1, "5": 0, "6": 1, "7": 1, "9": 0, "12": 1 },
      { "1": 1, "3": 0, "4": 0, "5": 1, "7": 0, "8": 0, "10": 1, "12": 1 },
      { "1": 1, "3": 0, "4": 0, "5": 1, "7": 1, "9": 1, "10": 0, "12": 1 },
      { "1": 1, "3": 0, "4": 0, "5": 1, "7": 1, "9": 0, "12": 1 },
    ],
    "6": [
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 0, "2": 0, "3": 0, "4": 0, "6": 0, "7": 0, "8": 1, "13": 0 },
      { "1": 1, "2": 1, "3": 1, "5": 0, "6": 0, "7": 0, "8": 1, "11": 1 },
      { "2": 1, "3": 1, "4": 1, "5": 1, "7": 0, "8": 1, "9": 0, "12": 1 },
    ],
    "7": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
    ],
    "8": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "7": 1, "12": 0, "13": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 1, "5": 0, "7": 1, "12": 0, "13": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 1, "7": 1, "12": 0, "13": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 1, "7": 1, "9": 0, "11": 1, "13": 1 },
      { "2": 1, "3": 1, "4": 1, "5": 1, "8": 0, "9": 0, "10": 1, "11": 0 },
    ],
    "9": [],
    "10": [],
  },
  "4": {
    "1": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 0, "7": 0, "8": 1, "11": 1 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 1, "7": 0, "8": 0, "12": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "7": 0, "8": 1, "11": 1, "12": 0 },
      { "1": 0, "2": 0, "4": 1, "5": 0, "6": 0, "11": 0, "12": 0, "13": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 0, "8": 1, "11": 1, "12": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 0, "8": 1, "11": 0, "13": 0 },
      { "1": 0, "2": 0, "4": 0, "7": 0, "8": 0, "10": 0, "12": 1, "13": 1 },
      { "1": 0, "2": 0, "4": 0, "7": 1, "9": 1, "10": 1, "12": 1, "13": 1 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 1, "7": 1, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 1, "7": 0, "8": 1, "11": 1 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 0, "8": 0, "12": 0 },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 1, "12": 0 },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      { "1": 0, "2": 1, "4": 0, "5": 0, "6": 0, "7": 1, "8": 1, "10": 0 },
    ],
    "3": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
    ],
    "4": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      { "1": 1, "2": 0, "3": 0, "4": 1, "5": 1, "7": 0, "8": 1, "13": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 0, "7": 0, "8": 1, "13": 0 },
    ],
    "5": [
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      { "1": 1, "2": 0, "3": 1, "4": 0, "5": 1, "7": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 0, "7": 0, "8": 0, "10": 1, "12": 1 },
      { "1": 0, "2": 1, "3": 1, "5": 0, "7": 0, "8": 1, "11": 1, "12": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 0, "7": 1, "9": 1, "10": 0, "12": 1 },
      { "1": 1, "2": 1, "4": 0, "5": 1, "7": 0, "8": 1, "11": 1, "12": 1 },
      { "1": 0, "3": 1, "4": 1, "5": 1, "6": 0, "7": 1, "8": 0, "12": 0 },
      { "1": 0, "3": 1, "4": 1, "5": 1, "7": 0, "8": 0, "9": 0, "10": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 0, "7": 1, "9": 0, "12": 1 },
    ],
    "6": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      { "1": 0, "2": 1, "4": 0, "5": 0, "6": 0, "7": 0, "8": 0, "12": 0 },
      { "1": 0, "3": 0, "4": 1, "7": 0, "8": 0, "10": 0, "12": 1, "13": 0 },
      { "1": 0, "3": 0, "7": 0, "8": 1, "9": 0, "11": 0, "12": 1, "13": 1 },
    ],
    "7": [
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
    ],
    "8": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 1, "2": 0, "3": 1, "4": 1, "7": 0, "8": 1, "11": 1, "13": 1 },
      { "1": 0, "2": 0, "3": 0, "5": 0, "8": 0, "9": 0, "10": 1, "12": 1 },
      { "1": 0, "2": 1, "5": 0, "6": 0, "7": 1, "8": 0, "9": 0, "12": 0 },
      { "2": 1, "3": 1, "4": 1, "5": 1, "7": 0, "8": 1, "9": 0, "12": 1 },
      { "2": 1, "3": 1, "4": 1, "5": 1, "7": 0, "8": 0, "10": 0, "12": 1 },
    ],
    "9": [],
    "10": [],
  },
  "5": {
    "1": [
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 0, "2": 0, "4": 0, "5": 0, "7": 0, "8": 1, "11": 1, "12": 0 },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      { "1": 0, "2": 0, "3": 1, "5": 0, "6": 0, "7": 1, "8": 1, "10": 0 },
      { "1": 0, "2": 0, "3": 0, "5": 0, "7": 1, "8": 1, "9": 0, "12": 0 },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      { "1": 0, "2": 0, "5": 0, "6": 1, "8": 0, "9": 0, "10": 1, "11": 1 },
    ],
    "4": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 1, "2": 0, "3": 0, "4": 0, "5": 1, "7": 0, "8": 1, "13": 0 },
    ],
    "5": [
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 1,
        "13": 0,
      },
      { "1": 0, "2": 0, "3": 1, "5": 0, "7": 0, "8": 1, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "4": 1, "5": 0, "6": 0, "7": 0, "10": 0, "12": 1 },
      { "1": 1, "3": 0, "4": 1, "6": 0, "7": 0, "10": 0, "11": 1, "13": 1 },
      { "3": 1, "4": 1, "5": 1, "6": 1, "7": 0, "8": 1, "9": 1, "12": 0 },
      { "1": 1, "3": 1, "4": 1, "5": 1, "6": 0, "7": 0, "10": 0 },
      { "1": 0, "3": 1, "4": 1, "5": 1, "7": 0, "8": 1, "9": 0 },
    ],
    "6": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "3": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      { "1": 0, "2": 0, "3": 1, "4": 1, "6": 0, "7": 0, "8": 0, "12": 0 },
      { "1": 0, "2": 0, "3": 0, "5": 0, "6": 0, "7": 0, "8": 0, "12": 0 },
      { "1": 0, "2": 1, "4": 1, "5": 1, "6": 0, "7": 0, "8": 0, "12": 0 },
    ],
    "7": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
    ],
    "8": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      { "1": 0, "2": 0, "3": 0, "4": 1, "5": 1, "6": 0, "7": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 1, "6": 0, "7": 0, "10": 0 },
      { "1": 0, "2": 0, "3": 0, "5": 0, "7": 0, "8": 1, "9": 0, "12": 1 },
      { "1": 0, "2": 0, "3": 0, "5": 0, "7": 0, "8": 0, "10": 0, "12": 1 },
      { "1": 0, "2": 1, "4": 0, "5": 0, "6": 0, "7": 0, "10": 1, "12": 0 },
      { "1": 0, "2": 1, "4": 0, "5": 1, "6": 0, "7": 0, "10": 0, "12": 1 },
      { "1": 0, "2": 1, "4": 0, "5": 0, "6": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "2": 1, "5": 0, "6": 0, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "1": 0, "2": 1, "5": 0, "6": 1, "7": 0, "8": 1, "9": 1, "12": 0 },
      { "1": 0, "2": 1, "5": 0, "6": 0, "7": 0, "10": 0 },
    ],
    "9": [],
    "10": [
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      { "1": 1, "3": 1, "5": 1, "6": 0, "7": 1, "8": 0, "9": 0, "12": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 0, "7": 1, "8": 0, "9": 0, "12": 0 },
      { "1": 0, "6": 0, "7": 1, "8": 0, "9": 0, "10": 1, "12": 1, "13": 0 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 0, "12": 0 },
    ],
  },
  "6": {
    "1": [],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 0, "10": 0, "12": 0 },
      { "2": 0, "3": 1, "6": 1, "7": 1, "8": 0, "10": 0, "12": 1, "13": 0 },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
    ],
    "4": [
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "12": 0,
        "13": 0,
      },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 0, "8": 1, "12": 0, "13": 0 },
      { "1": 1, "2": 0, "3": 0, "6": 0, "7": 0, "10": 0, "11": 1, "13": 1 },
    ],
    "5": [
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "14": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      { "1": 1, "3": 0, "4": 1, "6": 0, "7": 0, "10": 0, "11": 1, "13": 0 },
      { "1": 1, "3": 0, "4": 1, "6": 0, "7": 0, "10": 0, "11": 0 },
      { "1": 1, "3": 0, "4": 1, "7": 1, "8": 1, "9": 0, "13": 0 },
    ],
    "6": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "2": 0,
        "3": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "2": 0,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 0, "10": 1, "12": 0 },
    ],
    "7": [],
    "8": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "13": 0,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
        "13": 0,
        "14": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
        "14": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "13": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 1,
        "14": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "8": 1,
        "9": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "13": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "10": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      { "1": 1, "2": 1, "3": 0, "4": 0, "6": 0, "7": 0, "10": 1, "12": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 0, "6": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "2": 1, "4": 0, "5": 0, "6": 0, "7": 1, "8": 1, "9": 1 },
      { "1": 0, "2": 1, "4": 0, "5": 1, "6": 0, "7": 0, "9": 1, "10": 1 },
      { "1": 0, "2": 1, "4": 0, "5": 1, "6": 0, "7": 0, "9": 0, "12": 0 },
      { "1": 0, "2": 1, "4": 0, "5": 1, "6": 1, "8": 1, "9": 0, "12": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 0, "6": 0, "7": 0, "10": 0 },
    ],
    "9": [],
    "10": [
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      {
        "1": 1,
        "3": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 1,
      },
      {
        "1": 1,
        "3": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 1,
        "13": 0,
      },
      {
        "1": 1,
        "3": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
        "13": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "12": 0,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "12": 1,
      },
      {
        "1": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "13": 1,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "13": 0,
      },
      {
        "1": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "13": 1,
      },
      { "1": 1, "3": 1, "5": 0, "6": 0, "7": 1, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "7": 1, "8": 1, "9": 0, "10": 0 },
      { "1": 1, "3": 1, "5": 1, "6": 1, "7": 0, "8": 1, "9": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 0, "6": 1, "8": 1, "9": 0, "10": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 1, "8": 1, "9": 0, "10": 0, "12": 0 },
      { "1": 1, "3": 1, "6": 1, "7": 0, "8": 1, "10": 0, "12": 1, "13": 0 },
      { "1": 1, "3": 1, "6": 0, "7": 0, "9": 0, "10": 1, "12": 1, "13": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 0, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "1": 0, "4": 0, "5": 0, "6": 0, "7": 1, "8": 1, "9": 0, "10": 0 },
      { "1": 0, "4": 0, "5": 1, "6": 0, "7": 1, "8": 0, "9": 0, "10": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 1, "7": 0, "8": 1, "9": 1, "12": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 1, "8": 1, "9": 0, "10": 0, "12": 0 },
      { "1": 0, "4": 0, "5": 1, "6": 1, "8": 1, "9": 0, "10": 1, "12": 1 },
      { "1": 0, "4": 1, "6": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 0, "10": 0, "12": 1 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 1, "10": 0, "12": 0 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 1, "9": 0, "10": 1, "12": 0 },
      { "1": 0, "4": 1, "6": 1, "7": 0, "8": 0, "9": 0, "11": 0, "13": 1 },
      { "1": 0, "6": 0, "7": 1, "8": 0, "9": 0, "10": 1, "12": 1, "13": 1 },
      { "1": 0, "6": 0, "7": 1, "8": 1, "9": 0, "10": 1, "12": 1, "13": 0 },
      { "1": 0, "6": 1, "7": 1, "8": 1, "9": 0, "10": 0, "12": 1, "13": 0 },
      { "1": 1, "3": 1, "5": 0, "6": 0, "7": 0, "10": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "7": 0, "10": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 1, "6": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 1, "3": 0, "6": 0, "7": 1, "8": 0, "9": 0, "12": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 0, "7": 0, "10": 1, "12": 0 },
      { "1": 0, "4": 0, "5": 1, "6": 0, "7": 0, "10": 0, "12": 1 },
      { "1": 0, "4": 0, "5": 0, "6": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "1": 0, "4": 1, "6": 0, "7": 1, "8": 1, "9": 0, "10": 0 },
      { "1": 0, "4": 1, "6": 1, "7": 0, "8": 1, "9": 1, "12": 0 },
      { "1": 0, "4": 1, "6": 1, "8": 1, "9": 0, "10": 0, "12": 0 },
      { "1": 0, "6": 1, "7": 0, "8": 1, "10": 0, "12": 1, "13": 0 },
      { "1": 0, "6": 0, "7": 0, "9": 0, "10": 1, "12": 1, "13": 0 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "7": 0, "10": 0 },
      { "1": 0, "4": 0, "5": 0, "6": 0, "7": 0, "10": 0 },
      { "1": 0, "4": 1, "6": 0, "7": 0, "10": 1, "12": 0 },
      { "1": 0, "4": 1, "6": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "4": 1, "6": 0, "7": 0, "10": 0 },
    ],
  },
};
